import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationCapitalCard } from "web_myplann/Inspiration/Components/InspirationCapitalCard";
import { InspirationSection } from "web_myplann/Inspiration/Components/InspirationSection";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";

const R = Resources.Inspiration.EarlyFreedom;

type Props = {
	context: EarlyFreedomContext;
};

export const EarlyFreedomCapitalSection: FC<Props> = ({ context }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<InspirationSection title={t(R.capitalTitle)} gap={theme.spacingTokens.md}>
			<InspirationCapitalCard
				rows={[
					{
						label: t(R.rowExpenses),
						value: formatInspirationMoney(context.targetExpenses),
					},
					{
						label: t(R.rowPassive),
						value: `− ${formatInspirationMoney(context.passiveToday)}`,
						valueColor: theme.palette.green.main,
					},
				]}
				remaining={{
					label: t(R.rowGap),
					value: formatInspirationMoney(context.gap),
					suffix: t(R.perMonth),
				}}
				capital={{
					label: t(R.capitalLabel),
					value: formatInspirationMoney(context.targetCapital),
					note: t(R.capitalNote),
				}}
			/>

			{context.passiveToday > 0 && (
				<Typography variant="hint" color={theme.palette.grey[400]} relaxed>
					{t(R.capitalDisclaimer)}
				</Typography>
			)}
		</InspirationSection>
	);
};
